import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Home, Users, Heart, Phone } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

const Hausbesuche = () => {
  const benefits = [
    {
      icon: Home,
      title: 'In gewohnter Umgebung',
      description: 'Behandlung in Ihrem vertrauten Zuhause, wo Sie sich am wohlsten fühlen'
    },
    {
      icon: Users,
      title: 'Für alle Altersgruppen',
      description: 'Besonders geeignet für ältere Patienten und Menschen mit eingeschränkter Mobilität'
    },
    {
      icon: Heart,
      title: 'Individuelle Betreuung',
      description: 'Ungeteilte Aufmerksamkeit und Behandlung in vertrauter Atmosphäre'
    }
  ];

  return (
    <div className="page-container">
      <section className="page-hero">
        <div className="section-container">
          <h1 className="page-title">Hausbesuche in Apolda</h1>
          <p className="page-subtitle">
            Physiotherapie bei Ihnen zu Hause
          </p>
        </div>
      </section>

      <section className="page-content">
        <div className="section-container">
          <div className="hausbesuche-content-layout">
            <div className="hausbesuche-main-text">
              <h2 className="subsection-title">Wir kommen zu Ihnen</h2>
              <p className="text-content">
                Wenn der Weg in unsere Praxis für Sie eine Herausforderung darstellt, 
                bieten wir Ihnen die Möglichkeit der physiotherapeutischen Behandlung in 
                Ihrem eigenen Zuhause an.
              </p>
              <p className="text-content">
                Hausbesuche ermöglichen es uns, Sie in Ihrer gewohnten Umgebung zu behandeln 
                und die Therapie optimal an Ihre häuslichen Gegebenheiten anzupassen.
              </p>

              <h3 className="subsection-subtitle">Wann sind Hausbesuche sinnvoll?</h3>
              <ul className="content-list">
                <li>Bei stark eingeschränkter Mobilität</li>
                <li>Nach Operationen in der Rehabilitationsphase</li>
                <li>Für ältere Patienten, denen der Weg beschwerlich fällt</li>
                <li>Bei akuten Beschwerden, die eine Fortbewegung erschweren</li>
                <li>Wenn der Transport zur Praxis nicht möglich ist</li>
              </ul>

              <h3 className="subsection-subtitle">Behandlungen im Hausbesuch</h3>
              <p className="text-content">
                Im Rahmen von Hausbesuchen können wir die meisten physiotherapeutischen 
                Behandlungen durchführen, die auch in der Praxis möglich sind:
              </p>
              <ul className="content-list">
                <li>Krankengymnastik und Bewegungstherapie</li>
                <li>Manuelle Therapie</li>
                <li>Massage und Weichteiltechniken</li>
                <li>Lymphdrainage</li>
                <li>Übungen zur Sturzprophylaxe</li>
              </ul>
            </div>
          </div>

          <div className="benefits-grid">
            {benefits.map((benefit, index) => {
              const IconComponent = benefit.icon;
              return (
                <Card key={index} className="benefit-card">
                  <CardContent className="benefit-card-content">
                    <IconComponent className="benefit-icon" />
                    <h3 className="benefit-title">{benefit.title}</h3>
                    <p className="benefit-description">{benefit.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          <div className="hausbesuche-requirements">
            <Card className="requirements-card">
              <CardContent className="requirements-content">
                <h3 className="subsection-subtitle">Voraussetzungen</h3>
                <p className="text-content">
                  Hausbesuche werden auf ärztliche Verordnung durchgeführt. Ihr Arzt muss 
                  auf der Verordnung den Hausbesuch ausdrücklich vermerken und medizinisch 
                  begründen.
                </p>
                <p className="text-content">
                  Die Kosten werden bei entsprechender Verordnung von Ihrer Krankenkasse übernommen.
                </p>
              </CardContent>
            </Card>
          </div>

          <div className="hausbesuche-cta">
            <Card className="cta-card">
              <CardContent className="cta-card-content">
                <Phone className="cta-icon" />
                <h3 className="cta-title">Hausbesuch vereinbaren</h3>
                <p className="cta-text">
                  Sprechen Sie mit Ihrem Arzt über die Möglichkeit eines Hausbesuchs und 
                  kontaktieren Sie uns für die Terminvereinbarung.
                </p>
                <Button asChild size="lg" className="cta-button">
                  <Link to="/kontakt">Jetzt Kontakt aufnehmen</Link>
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Hausbesuche;